export default {
  en: {
    'Product': 'Product',
    'Configure': 'Configure',
    'Quantity': 'Quantity',
    'Subscribe': 'Subscribe',
    'Buy': 'Buy',
    waver: 'I agree that LATC will grant access immediately and that I thereby waive my right of withdrawal.',
    rightwithdrawal: 'Right of withdrawal',
  },
  de: {
    'Product': 'Produkt',
    'Configure': 'Konfigurieren',
    'Quantity': 'Anzahl',
    'Subscribe': 'Abonnieren',
    'Buy': 'Kaufen',
    waver: 'Ich stimme zu, dass LATC sofort mit dem Zugang beginnt und ich dadurch mein Widerrufsrecht verliere.',
    rightwithdrawal: 'Widerrufsrecht',
  },
  at: {},
  es: {
    'Product': 'Producto',
    'Configure': 'Configurar',
    'Quantity': 'Cantidad',
    'Subscribe': 'Suscribirse',
    'Buy': 'Comprar',
    waver: 'Acepto que LATC comience el acceso de inmediato y que, al hacerlo, pierdo mi derecho de desistimiento.',
    rightwithdrawal: 'Derecho de desistimiento',
  },
  uk: {
    'Product': 'Продукт',
    'Configure': 'Налаштувати',
    'Quantity': 'Кількість',
    'Subscribe': 'Підписатися',
    'Buy': 'Купити',
    waver: 'Я погоджуюсь, що LATC надасть доступ негайно, і тим самим я втрачаю право на відмову.',
    rightwithdrawal: 'Право на відмову',
  }
}
